import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 bg-forest text-white/90">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <img src="/logo.png" alt="EasyStay" className="h-9 w-9 rounded-xl object-cover" />
              <span className="font-display text-xl font-bold text-white">
                Easy<span className="text-copper">Stay</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-white/70">
              Zambia&apos;s short-stay marketplace — hotels, lodges &amp; guest houses booked by the hour or by the night. Welcome to EasyStay.
            </p>
            <div className="mt-4 space-y-1 text-sm text-white/70">
              <div>
                <a href="mailto:hello@easystayzm.com" className="hover:text-copper">hello@easystayzm.com</a>
              </div>
              <div>
                <a href="https://easystayzm.com" className="hover:text-copper">easystayzm.com</a>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white">Explore</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/search?city=Lusaka" className="hover:text-copper">Lusaka</Link></li>
              <li><Link to="/search?city=Livingstone" className="hover:text-copper">Livingstone</Link></li>
              <li><Link to="/search?city=Ndola" className="hover:text-copper">Ndola</Link></li>
              <li><Link to="/search?city=Siavonga" className="hover:text-copper">Siavonga</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white">Company</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/host" className="hover:text-copper">Become a host</Link></li>
              <li><Link to="/advertise" data-testid="footer-advertise" className="hover:text-copper">Advertise with us</Link></li>
              <li><Link to="/trust-safety" data-testid="footer-trust" className="hover:text-copper">Trust &amp; Safety</Link></li>
              <li><Link to="/terms/host" className="hover:text-copper">Host agreement</Link></li>
              <li><Link to="/terms/guest" className="hover:text-copper">Guest terms</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-copper">Privacy policy</Link></li>
              <li><Link to="/contact" data-testid="footer-contact" className="hover:text-copper">Contact us</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white">Payments</h4>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li>MTN Mobile Money</li>
              <li>Airtel Money</li>
              <li>Zamtel Kwacha</li>
              <li>Visa / Mastercard</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-white/10 pt-6 text-xs text-white/60">
          © {new Date().getFullYear()} EasyStay Zambia · <a href="https://easystayzm.com" className="hover:text-copper">easystayzm.com</a> · All prices displayed in Zambian Kwacha unless toggled.
        </div>
      </div>
    </footer>
  );
}
